import React, { useState } from 'react';
import { Box, HStack, Text, VStack, Icon, Flex } from '@chakra-ui/react';
import { FiChevronUp, FiChevronDown } from 'react-icons/fi';
import { getGuidelines } from '../../utils/creativeBriefUtils';
import { Campaign, Collab } from '@foodfluence/shared';
import { ff } from '../../../../theme';

interface CollabInstructionsProps {
  isRequest?: boolean;
  campaign: Campaign;
  collab: Collab;
}

const CollabInstructions: React.FC<CollabInstructionsProps> = ({ isRequest, campaign, collab }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  if (isRequest) {
    return null;
  }

  const isAccepted = collab.status !== 'pendingInfluencerApproval';
  const guidelines = getGuidelines(isAccepted, campaign, collab);

  if (guidelines.length === 0) {
    return null;
  }

  return (
    <Box fontFamily="display">
      <HStack
        as="button"
        w="100%"
        minH="44px"
        mb={1}
        cursor="pointer"
        onClick={() => setIsExpanded((prev) => !prev)}
        aria-expanded={isExpanded}
        justify="space-between"
      >
        <Text as="h2" m={0} textStyle="eyebrow" fontSize="12px" color={ff.text2}>
          Instructions
        </Text>
        <Icon as={isExpanded ? FiChevronUp : FiChevronDown} boxSize={5} color={ff.muted} />
      </HStack>
      {isExpanded && (
        <Box border="1px solid" borderColor={ff.card} borderRadius="20px" px={4}>
          {!isAccepted && (
            <Text fontSize="13px" color={ff.text2} pt={4} pb={1}>
              Once you accept the collaboration:
            </Text>
          )}
          <VStack spacing={0} align="stretch" divider={<Box h="1px" bg={ff.line} border="none" />}>
            {guidelines.map((guideline, index) => (
              <HStack key={index} py={4} spacing={3} align="start">
                <Flex
                  bg={ff.grey}
                  borderRadius="full"
                  boxSize="28px"
                  align="center"
                  justify="center"
                  flexShrink={0}
                >
                  <Text fontSize="13px" fontWeight={600} color={ff.ink}>
                    {index + 1}
                  </Text>
                </Flex>
                <VStack align="start" spacing="4px" flex={1} pt="3px">
                  <Text fontSize="15px" fontWeight={600} color={ff.ink} lineHeight="1.3">
                    {guideline.header}
                  </Text>
                  <Text fontSize="15px" color={ff.body} lineHeight="1.5">
                    {guideline.details}
                  </Text>
                </VStack>
              </HStack>
            ))}
          </VStack>
        </Box>
      )}
    </Box>
  );
};

export default CollabInstructions;
